import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { FrameworkService } from "@core/framework/framework.service"

@Directive({ selector: '[customBuild]' })
export class M4UCustomBuildDirective
{
    private hasView = false;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private framework: FrameworkService) { }

    @Input() set customBuild(value: string)
    {
        var bTrue = this.framework.IsCustomBuild(value);
        if (this.Reverse) bTrue = !bTrue;
        if (bTrue && !this.hasView)
        {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
        } else if (bTrue && this.hasView)
        {
            this.viewContainer.clear();
            this.hasView = false;
        }
    }

    @Input() Reverse: boolean;
}